export default "__VITE_ASSET__C7qRikJl__"